export default __webpack_public_path__ + "dollar-symbol.png";